enum GroupingType {
  COLLECTION = "collection",
  MY_LIST = "mylist",
  SITE = "site",
}

export default GroupingType;
